import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { MdOndemandVideo, MdAccountCircle, MdArticle } from "react-icons/md";
import { TiSpiral } from "react-icons/ti";

export const NavBar: React.FC = () => {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const { isLoggedIn, accessTier } = useAppContext();

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Link to="/" className="nav-link">
          💜 IPWD
        </Link>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : true);
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#content">
            { accessTier > 0 ?
              <>
              <Nav.Item>
                <Nav.Link as={Link} to="/files" onClick={() => updateExpanded(false)}>
                  <MdOndemandVideo style={{ marginBottom: "2px" }} /> Files
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/help" onClick={() => updateExpanded(false)}>
                  <MdArticle style={{ marginBottom: "2px" }} /> Help
                </Nav.Link>
              </Nav.Item>
              </>
              : <></>
            }
            { isLoggedIn ? 
              <Nav.Item>
                <Nav.Link as={Link} to="/profile" onClick={() => updateExpanded(false)}>
                <MdAccountCircle style={{ marginBottom: "2px" }} /> Profile
                </Nav.Link>
              </Nav.Item> 
              :
              <Nav.Item>
                <Nav.Link as={Link} to="/login" onClick={() => updateExpanded(false)}>
                  <MdAccountCircle style={{ marginBottom: "2px" }} /> Login
                </Nav.Link>
              </Nav.Item>
            }
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
